import { ReadableAtom, computed } from 'nanostores';
import { startSpan as sentryStartSpan, captureException } from '@sentry/browser';
import { AppointmentSlot } from '../types';
import { CalendarType } from '../../types/consultation';

const en = window.en;
const serviceUrl = window.craftConfig.global.leadServiceUrl;

// Lightweight wrapper so spans stay optional in older browsers while giving context on network calls.
const startSpan = <T>(name: string, op: string, attributes: Record<string, unknown>, cb: () => T) => (sentryStartSpan as any)?.({ name, op, attributes }, cb) ?? cb();

export default function initCalendarStore(calendar: ReadableAtom<CalendarType | undefined>): ReadableAtom<AppointmentSlot[] | Promise<AppointmentSlot[]>> {
  return computed(calendar, $calendar => fetchAvailableAppointments($calendar || (en ? CalendarType.SalesExpat : CalendarType.Sales)));
}

async function fetchAvailableAppointments(calendar: CalendarType) {
  return startSpan('consultation.calendar.load', 'http.client', { calendar }, () =>
    fetch(`${serviceUrl}/consultation/available-slots?calendar=${calendar}`)
      .then(response => {
        if (!response.ok) {
          const error = new Error('Error fetching appointment data: ' + response.status);
          captureException(error, { extra: { calendar, status: response.status } });
          throw error;
        }
        return response.json() as Promise<{ result: AppointmentSlot[] }>;
      })
      .then(data => data.result)
  );
}
